import { useSelector } from "react-redux";

// Custom hook to get the ID from the Redux persisted state
const usePersistedId = () => {
  const id = useSelector((state) => state.user.id);
  return id; // Assuming username contains the id
};

export default usePersistedId;
